import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const articlesUserReactionApi = createApi({
  reducerPath: 'articlesUserReactionApi',
  baseQuery: rtkBaseQuery('/staff/ReactionUser'),
  tagTypes: ['Reactions'],

  endpoints: (builder) => ({
    createUpdateDeleteReactions: builder.mutation({
      query: (body) => ({
        url: '/CreateOrUpdateOrDelete',
        method: 'POST',
        body,
      }),
    }),
    getReactionsById: builder.query({
      query: ({ id }) => ({
        url: `/GetById/${id}`,
      }),
    }),
    getAllReactions: builder.query({
      query: () => '/GetAll',
      providesTags: ['Reactions'],
    }),
  }),
});

export const {
  useCreateUpdateDeleteReactionsMutation,
  useGetReactionsByIdQuery,
  useGetAllReactionsQuery,
} = articlesUserReactionApi;
